import React, { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { getConfigValue } from '../util/getConfigValue';
import { AppContext } from '../util/AppContext';

function ApplicationSelectionHomePage() {      
    const [appState] = useContext(AppContext);
    const navigate = useNavigate();

    const pageTitle = getConfigValue(appState?.config?.LandingPage?.Title, appState)?.Value || "";
    const pageSubtitle = getConfigValue(appState?.config?.LandingPage?.Subtitle, appState)?.Value || "";
    const pageLogo = getConfigValue(appState?.config?.LandingPage?.Logo, appState);
    const pageLogoImage = pageLogo?.Value;
    const pageLogoHeight = pageLogo?.ImageHeight || "60px";
    const pageLogoWidth = pageLogo?.ImageWidth || "60px";

    const availableProducts = [
        {
            Icon: getConfigValue(appState?.config?.LandingPage?.Product?.POD?.Icon, appState)?.Value || undefined,
            Border: getConfigValue(appState?.config?.LandingPage?.Product?.POD?.Border, appState)?.Value || '',
            Title: getConfigValue(appState?.config?.LandingPage?.Product?.POD?.Title, appState)?.Value || '',
            SubHeading: getConfigValue(appState?.config?.LandingPage?.Product?.POD?.SubHeading, appState)?.Value || '',
            Description: getConfigValue(appState?.config?.LandingPage?.Product?.POD?.Description, appState)?.Value || '',
            NavigationUrl : '/',
            ImageWidth: getConfigValue(appState?.config?.LandingPage?.Product?.POD?.Icon, appState)?.ImageWidth || '70',
            ImageHeight: getConfigValue(appState?.config?.LandingPage?.Product?.POD?.Icon, appState)?.ImageHeight || '70',
        }, 
        {
            Icon: getConfigValue(appState?.config?.LandingPage?.Product?.AGI?.Icon, appState)?.Value || undefined,
            Border: getConfigValue(appState?.config?.LandingPage?.Product?.AGI?.Border, appState)?.Value || '',
            Title: getConfigValue(appState?.config?.LandingPage?.Product?.AGI?.Title, appState)?.Value || '',
            SubHeading: getConfigValue(appState?.config?.LandingPage?.Product?.AGI?.SubHeading, appState)?.Value || '',
            Description: getConfigValue(appState?.config?.LandingPage?.Product?.AGI?.Description, appState)?.Value || '',
            NavigationUrl : process.env.REACT_APP_AGI_URL,
            OpenInNewPage: getConfigValue(appState?.config?.LandingPage?.Product?.AGI?.OpenInNewPage, appState)?.Value || true,
            ImageWidth: getConfigValue(appState?.config?.LandingPage?.Product?.AGI?.Icon, appState)?.ImageWidth || '70',
            ImageHeight: getConfigValue(appState?.config?.LandingPage?.Product?.AGI?.Icon, appState)?.ImageHeight || '70',
        }];

    const setLandingPageShownFlag = () => {
        //once a selection is made and navigated away from this page, set the flag so this page is not shown again
        sessionStorage.setItem("hasShownApplicationSelection", "true");
    }

    const handleClick = (product) => {        
        if (product.NavigationUrl.toLowerCase().startsWith('http')) {
            if(product.OpenInNewPage?.toLowerCase() === 'true') {
                window.open(product.NavigationUrl, '_blank');
                return;
            }            
            setLandingPageShownFlag();
            window.location.href = product.NavigationUrl;
        } else {
            setLandingPageShownFlag();
            navigate(product.NavigationUrl);
        }
    };

    const handleKeyDown = (event, product) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleClick(product);
        }
    };

    const styles = {
        logoPlaceholder: {
          marginBottom: '40px',
          width: pageLogoWidth,
          height: pageLogoHeight,
          backgroundColor: '#e8f0fe',
          borderRadius: '8px'
        },
        tile: {
          borderRadius: '12px',
          cursor: 'pointer',
          minHeight: '371px',
          maxHeight: '371px'
          
        },
        iconWrapper: {
          width: '70px',
          height: '70px',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '20px'
        },
        img : {
            width: '100%', 
            height: '100%', 
            objectFit: 'contain'
        }
      };

    return (
        <div>
            <div className="container-xl">
                <div className="row">
                    <h1 className="d-flex justify-content-between align-items-center mb-3 mt-3 mt-4 type-24">{pageTitle}</h1>
                    <p className="type-20 color-grey-d1 mb-5">{pageSubtitle}</p>
                </div>
            </div>

            <div className="container-xl mt-3 mt-md-4">
                <hr className="my-4 d-lg-none" />
                <div className="container-xl">
                    <div>
                        <div className="card pd-card pt-4 pt-md-7 pb-4 pb-md-7" >
                            <div className="row justify-content-center">
                                <div style={styles.logoPlaceholder}>
                                <img src={pageLogoImage} alt="Logo" style={{...styles.img, borderRadius: '8px'}} />
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                {availableProducts.map((product) => (
                                    <div key={product.Title} className="col-10 col-md-5 mb-6 mb-md-0">
                                    <button 
                                        key={product.Title} 
                                        className="btn-tile pt-6 pb-6 mb-3" 
                                        style={{...styles.tile, outline: 'revert'}} 
                                        onClick={() => handleClick(product)}
                                        onKeyDown={(e) => handleKeyDown(e, product)}
                                        aria-label={`${product.Title} - ${product.SubHeading}`}
                                    >
                                        <div style={{...styles.iconWrapper, border: `${product.Border}`, width: `${product.ImageWidth}px`, height: `${product.ImageHeight}px`}}>
                                        <img src={product.Icon} alt={product.Title} style={styles.img} />
                                        </div>
                                        <h2 className="type-20 fw-bold">{product.Title}</h2>
                                        <p className="type-20 color-grey-d1 mb-5">{product.SubHeading}</p>
                                        <p className="nav-breadcrumb-item active">
                                        {product.Description}
                                        </p>
                                    </button>
                                    </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ApplicationSelectionHomePage